<template>
  <div
    class="service-card"
    :class="{ 'service-card--selected': selected }"
    @click="$emit('select', service)"
  >
    <div class="service-card__header">
      <div class="service-card__badges">
        <span
          class="service-card__badge"
          :class="`service-card__badge--${familyClass}`"
        >
          {{ service.family }}
        </span>
        <span
          v-if="countryLabel"
          class="service-card__country"
          :title="countryTitle"
          >{{ countryLabel }}</span
        >
      </div>
      <span class="service-card__meeting-type">
        <i :class="meetingTypeIcon" />
        {{ meetingTypeLabel }}
      </span>
    </div>

    <h4 class="service-card__name">{{ service.name }}</h4>

    <p
      v-if="serviceDescription"
      class="service-card__description"
      :class="{ 'service-card__description--expanded': descExpanded }"
    >
      {{ serviceDescription }}
    </p>
    <button
      v-if="serviceDescription && serviceDescription.length > 120"
      type="button"
      class="service-card__expand-btn"
      @click.stop="descExpanded = !descExpanded"
    >
      {{ descExpanded ? "Ver menos" : "Ver mais" }}
    </button>

    <div class="service-card__footer">
      <div class="service-card__price">
        <template v-if="displayPrice !== null">
          <strong class="w-full block">{{
            formatPrice(displayPrice, service.currency)
          }}</strong>
          <span class="service-card__fee-type"> {{ feeTypeLabel }}</span>
          <span v-if="showPromotionMeta" class="service-card__fee-type">
            -{{ promotionDiscountLabel }}</span
          >
          <div v-if="showPromotionMeta" class="service-card__fee-type">
            Valor anterior: {{ formatPrice(oldDisplayPrice, service.currency) }}
          </div>
        </template>
        <span v-else class="service-card__price--consult"
          >Preço sob consulta</span
        >
      </div>
      <div v-if="meetingDurationText" class="service-card__duration">
        <i class="pi pi-clock" />
        {{ meetingDurationText }}
      </div>
    </div>

    <Button
      label="Seleccionar"
      class="service-card__btn p-button-sm"
      @click.stop="$emit('select', service)"
    />
  </div>
</template>

<script>
export default {
  name: "ServiceCard",
  props: {
    service: { type: Object, required: true },
    selected: { type: Boolean, default: false },
  },
  emits: ["select"],
  data() {
    return { descExpanded: false };
  },
  computed: {
    serviceDescription() {
      return (
        this.service.appointmentsServiceDescription ||
        this.service.description ||
        ""
      );
    },
    displayPrice() {
      const raw =
        this.service.priceToShow !== undefined &&
        this.service.priceToShow !== null
          ? this.service.priceToShow
          : this.service.priceWithIva !== undefined &&
            this.service.priceWithIva !== null
          ? this.service.priceWithIva
          : this.service.price;
      if (raw === null || raw === undefined || raw === "") return null;
      return parseFloat(raw);
    },
    feeTypeLabel() {
      if (this.service.pricingSource === "card") return "Desconto Balcão Mais";
      if (this.service.pricingSource === "promotion") return "Promoção";
      return this.service.feeType || "";
    },
    oldDisplayPrice() {
      const raw = this.service.oldPriceToShow;
      if (raw === null || raw === undefined || raw === "") return null;
      const v = parseFloat(raw);
      return isNaN(v) ? null : v;
    },
    showPromotionMeta() {
      return (
        !!this.service.pricingSource &&
        this.oldDisplayPrice !== null &&
        this.service.discountPercent !== null &&
        this.service.discountPercent !== undefined
      );
    },
    promotionDiscountLabel() {
      const d = parseFloat(this.service.discountPercent);
      if (isNaN(d)) return "";
      if (Math.round(d) === d) return String(d) + "%";
      return d.toFixed(2).replace(".", ",") + "%";
    },
    meetingTypeIcon() {
      const map = {
        online: "pi pi-video",
        "on-site": "pi pi-map-marker",
        both: "pi pi-globe",
      };
      return map[this.service.meetingType] || "pi pi-calendar";
    },
    meetingTypeLabel() {
      const map = {
        online: "Online",
        "on-site": "Presencial",
        both: "Online ou Presencial",
      };
      return map[this.service.meetingType] || "";
    },
    familyClass() {
      return (this.service.family || "").toLowerCase().replace(/\s+/g, "-");
    },
    countryLabel() {
      const c = this.service.country;
      if (c == null || String(c).trim() === "") return "";
      return String(c).trim().toUpperCase();
    },
    countryTitle() {
      return this.countryLabel ? "País do serviço: " + this.countryLabel : "";
    },
    currencyByCountry() {
      return this.currencyFromCountry(this.service.country);
    },
    meetingDurationText() {
      return this.formatDuration(this.service.meetingDuration);
    },
  },
  methods: {
    formatPrice(price, currency) {
      const symbol = currency || this.currencyByCountry || "€";
      return `${symbol} ${price.toFixed(2).replace(".", ",")}`;
    },
    currencyFromCountry(country) {
      const map = {
        PT: "EUR",
        BR: "BRL",
        AO: "AOA",
        MZ: "MZN",
        GW: "XOF",
        CV: "CVE",
        ST: "STN",
        TL: "USD",
      };
      return map[String(country || "").toUpperCase()] || null;
    },
    formatDuration(duration) {
      if (!duration) return "";
      var d = String(duration);
      if (d === "00:00:00") return "";
      var h = 0;
      var m = 0;
      var isoMatch = d.match(/T(\d{2}):(\d{2}):(\d{2})/);
      if (isoMatch) {
        h = parseInt(isoMatch[1], 10);
        m = parseInt(isoMatch[2], 10);
      } else {
        var parts = d.split(":");
        h = parseInt(parts[0], 10);
        m = parseInt(parts[1], 10);
      }
      if (isNaN(h) || isNaN(m)) return "";
      if (h === 0 && m === 0) return "";
      if (h > 0 && m > 0) return h + "h " + m + "min";
      if (h > 0) return h + "h";
      return m + "min";
    },
  },
};
</script>
